import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const ProductCard = ({ product, index = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: (index % 4) * 0.06 }}
  >
    <Link to={`/products/${product.id}`} data-testid={`product-card-${product.id}`} className="group block">
      <div className="relative overflow-hidden bg-white aspect-[4/5]">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.04]"
        />
        <span className="absolute top-4 left-4 text-[10px] tracking-[0.25em] bg-ivory/85 backdrop-blur px-2.5 py-1 text-charcoal">
          {product.category.toUpperCase()}
        </span>
      </div>
      <div className="pt-4">
        <h3 className="font-serif text-2xl leading-tight group-hover:text-burgundy transition-colors duration-300">{product.name}</h3>
        <p className="text-xs tracking-[0.15em] text-gold mt-1">{product.descriptor.toUpperCase()}</p>
        <span className="mt-3 inline-block text-xs tracking-wide text-charcoal/70 relative after:absolute after:left-0 after:-bottom-0.5 after:h-px after:w-0 after:bg-gold group-hover:after:w-full after:transition-all after:duration-500">
          View Details →
        </span>
      </div>
    </Link>
  </motion.div>
);
